// extracted by mini-css-extract-plugin
export default {"quoterLayout":"quoterLayout_quoterLayout__MZGQP","content":"quoterLayout_content__D12Lu"};